import type { FC, ReactElement } from 'react';

import { Icon, IconName } from '@catalyze/ui';

import {
    FormTitleContainer,
    FormSubtitle,
    FormTitle as StyledFormTitle,
    StyledButton,
} from './styled';

interface IFormTitle {
    title: string;
    subtitle: string | ReactElement;
    goBack?: () => void;
}

export const FormTitle: FC<IFormTitle> = ({ title, subtitle, goBack }) => (
    <FormTitleContainer>
        {goBack && (
            <StyledButton onClick={goBack}>
                <Icon iconName={IconName.ARROW} />
            </StyledButton>
        )}
        <StyledFormTitle>{title}</StyledFormTitle>
        <FormSubtitle>{subtitle}</FormSubtitle>
    </FormTitleContainer>
);

FormTitle.defaultProps = {
    goBack: undefined,
};
